import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'statusApprovalsIcon' })
export class StatusApprovalsIconPipe implements PipeTransform {

  transform(statusName: string): string {
    if (statusName) {
      if (statusName === 'pending') {
        return 'access_alarms';
      } else if (statusName === 'approved') {
        return 'check_circle';
      } else if (statusName === 'refused') {
        return 'timelapse';
      } else if (statusName === 'canceled') {
        return 'close';
      } else if (statusName === 'new') {
        return 'add_circle_outline';
      }
    }
    return null;
  }
}
